import moment from 'moment'

const Config = {
  apiUrl: 'https://api.nexgenrx.com/api/v1',
  title: 'Global Benefits Member Web',
  hotjarKey: null,
  applicationInsightsKey: '56f76b1b-1a9f-42d2-b653-997fc2c2b144',
  dateFormat: 'DD-MMM-YYYY',
  defaultDateValue: 'N/A',
  defaultCurrency: 'N/A',
  defaultDateRange: 'TBD',
  defaultAPIDateFormat: moment.ISO_8601,
  helpEmail: 'benefits@globalben.com',
  helpGeneralNumber: '(800) 663-4500',
  providerSupportNumber: '(800) 663-4500',
  defaultPreviousYearsToShowClaims: 3,
  defaultPageSize: 20,
  debugMode: false,
  maxFileSize: 5242880,
  maxNoOfFilesToUpload: 5,
  AdjudicateDaysFromToday: 21,
  // white label key
  wlKey: 'glbl',
  useSSO: true,
  hideAccountInternalName: true,
  hideEmailSection: true,
  hidePasswordSection: true,
  hideSecurityQuestionsSection: true,
  hideBankingInfoSection: false,
  viewOnlyBanking: false,
  loginFallBack: 'https://www.globalben.com/Account/Login',
  useLocale: true,
  landingPage: 'Claims',
  showPhoneNumbers: true,
  showMvaQuestion: false,
  hideRedBit: false,
  hideClaimPaymentMessage: true,
  member: {
    benefits: {
      hideCoverage: false,
      hideEffectiveDate: false,
      hideExpiryDate: false
    },
    hcsa: {
      hideClaimsSubmission: false,
      hideCraText: false
    }
  },
  providers: {
    searchApiUrl: 'https://api.nexgenrx.com/api/v1/providers/search',
    specialitiesApiUrl: 'https://api.nexgenrx.com/api/v1/providers/specialty',
    searchKey: 'AIzaSyB6GUjvZYEa3ADXqVSZnh8VGvtGbcE8VYo',
    isTabAvailable: true
  },
  claimFormURLs: {
    dentalEN: 'https://www.nexgenrx.com/wp-content/uploads/Dental-Claim-Form-%E2%80%93-English.pdf',
    dentalFR: 'https://www.nexgenrx.com/wp-content/uploads/Dental-Claim-Form-%E2%80%93-French.pdf',
    EOBDrugEN: 'https://www.nexgenrx.com/wp-content/uploads/Drug-and-Extended-Health-Care-Claim-Form-%E2%80%93-English.pdf',
    EOBDrugFR: 'https://www.nexgenrx.com/wp-content/uploads/Drug-and-Extended-Health-Care-Claim-Form-%E2%80%93-French.pdf'
  }
}

export default Config



// WEBPACK FOOTER //
// ./src/Config.js